if (typeof $ == 'undefined') {
    //load jquery from cdn then excecute collectionTabsJS
    var script = document.createElement('script');
    script.src = "https://code.jquery.com/jquery-3.4.1.min.js";
    script.onload = function () {
        collectionBottom();
    };
    document.head.appendChild(script);
} else {
    collectionBottom();
}
function collectionBottom(){
  $(".collectionBottomContentReadmoreButton").on("click", function(e) {
    e.preventDefault();
    let parent = $(this).closest(".collectionBottomContent");
    parent.find(".collectionBottomContentReadmoreContent").slideToggle();
    $(this).toggleClass("open");
  });
}